import React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Toolbar from "@mui/material/Toolbar";

import MaterialBox from "../../../../components/MaterialBox";
import {
  setMiniSidenav,
  setTransparentNavbar,
  useMaterialUIController,
} from "../../../../context";
import { navbarContainer, navbar, navbarRow } from "./styles";
import Breadcrumbs from "./components/Breadcrumbs";
import NotificationItem from "./components/NotificationItem";
import MaterialAvatar from "../../../../components/MaterialAvatar";
import { Avatar, Badge, Box } from "@mui/material";
import stringAvatar from "../../../../functions/stringAvatar";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import LogoutIcon from "@mui/icons-material/Logout";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import "./index.css";
import { useAuthData } from "../../../../meefood/context/loginContext/LoginContextProvider";
import BadgeIcon from "@mui/icons-material/Badge";
import NotificationsIcon from "@mui/icons-material/Notifications";
import BASEURL from "../../../../pages/Utils/Baseurl";
import { GetNotificationCount } from "../../../../meefood/pages/manageComplaints/data";
import request from "graphql-request";

function DashboardNavbar({ absolute, light, isMini, notificationView }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator } =
    controller;
  const [openMenu, setOpenMenu] = useState(false);
  const route = useLocation().pathname.split("/").slice(1);

  const [notificationsCount, setNotificationsCount] = useState("");

  const { userImage, userId, userDetails } = useAuthData();

  const [user, setUser] = useState({
    name: "Ajith Kumar",
    picture: "",
    email: "",
    role: "",
  });
  const [pageState, setPageState] = useState({
    state: "init",
  });

  useEffect(() => {
    const getUser = () => {
      setUser({
        name: userDetails?.employeeName,
        email: userDetails?.username,
        picture: userImage,
        role: userDetails?.role?.role,
      });
      setPageState({
        state: "default",
      });
    };
    getUser();
    fetchNotificationCount();
  }, []);

  useEffect(() => {
    if (notificationView) {
      fetchNotificationCount();
    }
  }, [notificationView]);

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(
        dispatch,
        (fixedNavbar && window.scrollY === 0) || !fixedNavbar
      );
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);
  const navigate = useNavigate();
  const open = Boolean(openMenu);

  // Render the notifications menu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const newopen = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem
        icon={
          <>
            {user.picture ? (
              <Avatar
                alt={user.name}
                src={user.picture}
                sx={{ width: 45, height: 45, objectFit: "cover" }}
              />
            ) : (
              <MaterialAvatar
                size="sm"
                {...stringAvatar(user.name || user.email || "UNNAMED")}
              />
            )}
          </>
        }
        title={user.name || user.email}
      />
      {/* <NotificationItem
        id="email"
        icon={<AlternateEmailIcon />}
        title={user.email}
      /> */}
      <NotificationItem id="role" icon={<BadgeIcon />} title={user.role} />

      <NotificationItem
        id="logout"
        onClick={signOut}
        icon={<LogoutIcon />}
        title={"Logout"}
      />
    </Menu>
  );

  const signOut = () => {
    navigate("/sign-in");
    localStorage.clear();
    // logout();
  };

  const fetchNotificationCount = async () => {
    try {
      const res = await request(BASEURL, GetNotificationCount, {
        userId: userId,
      });
      setNotificationsCount(res?.getUnreadCount || "");
    } catch (error) {
      setNotificationsCount("");
    }
  };

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      // position="navbarType"
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        {pageState.state === "default" && (
          <Box
            sx={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <MaterialBox
              color="inherit"
              mb={{ xs: 1, md: 0 }}
              sx={(theme) => navbarRow(theme, { isMini })}
            >
              <MaterialBox
                display="flex"
                sx={{ alignItems: "center", justifyContent: "space-between" }}
              >
                <Icon
                  fontSize="medium"
                  onClick={handleMiniSidenav}
                  sx={{ cursor: "pointer", mb: 1, color: "#999" }}
                >
                  {miniSidenav ? <MenuOpenIcon /> : <MenuIcon />}
                </Icon>
                <MaterialBox>
                  <Breadcrumbs
                    icon={<HomeIcon />}
                    title={route[route.length - 1]}
                    route={route}
                    light={light}
                  />
                </MaterialBox>
              </MaterialBox>
            </MaterialBox>

            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "20px",
                }}
              ></div>
              <Badge
                badgeContent={notificationsCount}
                color="error" // Red badge for notifications
                sx={{
                  "& .MuiBadge-badge": {
                    right: 5, // Positioning badge on the top-right
                    top: 5,
                    boxShadow: "0 0 4px rgba(0, 0, 0, 0.3)", // Subtle shadow for badge
                    fontSize: "0.75rem", // Adjust badge font size
                  },
                }}
              >
                <IconButton
                  sx={{
                    mr: 1,
                    backgroundColor: "#fff", // Light purple background
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Subtle shadow
                    borderRadius: "50%", // Fully rounded
                    padding: 1, // Add padding for larger size
                    "&:hover": {
                      backgroundColor: "#fff", // Darker shade on hover
                    },
                  }}
                  onClick={() => navigate("/notification")}
                >
                  <NotificationsIcon />
                </IconButton>
              </Badge>
              {isMini ? null : (
                <MaterialBox sx={(theme) => navbarRow(theme, { isMini })}>
                  <IconButton
                    onClick={handleOpenMenu}
                    size="small"
                    aria-controls={open ? "account-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                  >
                    <MaterialAvatar
                      alt={user.name}
                      src={user.picture}
                      sx={{ width: 40, height: 40 }}
                      color="#2a9941"
                    />
                  </IconButton>
                  {renderMenu()}
                </MaterialBox>
              )}
            </div>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
}

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
